<template>
  <section :class="data.product_type=='one'?'mc-big-slider':'mc-main-page__product-slider mc-product-slider'">
    <div class="mc-container">
      <div class="mc-product-slider__title">
        {{data.name}}
      </div>
      <div :class="data.product_type=='tow'?'mc-product-slider__wrapper':'mc-big-slider__wrapper'">
        <button v-if="data.product_type=='one'" :class="'swiper-button swiper-button--prev simulated-hover swiper-button--prev'+uniqueId" type="button" aria-label="Предыдущий слайд">
          <svg class="swiper-button-icon" width="30" height="30" viewBox="0 0 30 30">
            <use xlink:href="/assets/svg/sprite.svg#arrow-line-left"></use>
          </svg>
        </button>
        <swiper
            wrapperTag="ul"
            :modules="modules"
            :scrollbar="data.product_type=='two'?{ draggable: true, el: '.swiper-scrollbar'+uniqueId}:false"
            :pagination="data.product_type=='one'?{enabled: true, clickable: true, el: '.swiper-pagination'+uniqueId}:false"
            :navigation="data.product_type=='one'?{enabled: true, nextEl: '.swiper-button--next'+uniqueId, prevEl: '.swiper-button--prev'+uniqueId}:false"

            :slides-per-view="data.product_type=='one'?1:2"
            :class="data.product_type=='one'?'mc-big-slider__slider':'mc-product-slider__slider'"
            :wrapperClass="data.product_type=='one'?'mc-big-slider__list':'mc-product-slider__list'">
          <swiper-slide v-for="product in data.products" :key="product.id" :class="data.product_type=='one'?'mc-big-slider__item':'mc-product-slider__item'" tag="li">
            <product-item :product="product" />
          </swiper-slide>
        </swiper>
        <div v-if="data.product_type=='two'" :class="'swiper-scrollbar swiper-scrollbar'+uniqueId"></div>
        <button v-if="data.product_type=='one'" :class="'swiper-button swiper-button--next simulated-hover swiper-button--next'+uniqueId" type="button" aria-label="Следующий слайд">
          <svg class="swiper-button-icon" width="30" height="30" viewBox="0 0 30 30">
            <use xlink:href="/assets/svg/sprite.svg#arrow-line-right"></use>
          </svg>
        </button>
        <div v-if="data.product_type=='one'" :class="'swiper-pagination swiper-pagination'+uniqueId"></div>
          </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import ProductItem from "../components/ProductItem.vue";


export default {
  name: 'ProductsBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modules: [Pagination, Navigation, Scrollbar],
      uniqueId: 'products-' + Math.random().toString(36).substring(2, 9) // Generate unique ID for scrollbar
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    ProductItem
  }
}
</script>